import { FileSelectConfig } from "./hooks/useFileSelect";

export const avatarFileSelectConfig: FileSelectConfig = {
  multiple: false,
  maxFileSize: 5 * 1024 * 1024,
  acceptTypes: "image/jpg, image/jpeg, image/png",
  compressionConfig: { image: "good" },
};
